export default "__VITE_ASSET__rU5yuSBp__"